import PropTypes from "prop-types";

import styles from "./styles.module.css";

const VideoTab = ({ videoUrl, title, isYoutubeVideo }) => {
  return (
    <div className={styles.wrapper}>
      {isYoutubeVideo ? (
        <iframe height="100%" width="100%" src={videoUrl?.split("&")[0]} title={videoUrl} allowfullscreen></iframe>
      ) : (
        <video src={videoUrl} title={title} controls width="100%" style={{ height: "inherit" }} />
      )}
    </div>
  );
};

VideoTab.propTypes = {
  videoUrl: PropTypes.string,
  title: PropTypes.string,
  isYoutubeVideo: PropTypes.bool,
};

export default VideoTab;
